import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarrierRating = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "carrierRating",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12459",
			"data-name": "Path 12459",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12460",
			"data-name": "Path 12460",
			d: "M19,22H5a2,2,0,0,1-2-2V4A2,2,0,0,1,5,2H19a2,2,0,0,1,2,2V20A2,2,0,0,1,19,22Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12461",
			"data-name": "Path 12461",
			d: "M16,15H8",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12462",
			"data-name": "Path 12462",
			d: "M14,18H10",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12463",
			"data-name": "Path 12463",
			d: "M12,10.663l1.5.79a.4.4,0,0,0,.579-.421L13.8,9.357l1.217-1.185a.4.4,0,0,0-.221-.681L13.11,7.247l-.752-1.525a.4.4,0,0,0-.716,0L10.89,7.247l-1.682.245a.4.4,0,0,0-.221.681L10.2,9.358l-.287,1.675a.4.4,0,0,0,.579.421l1.5-.791",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgCarrierRating;
